import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) { setErr(formatError(e)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 sm:p-12 relative">
      <div className="absolute inset-0 mandala-bg pointer-events-none" />
      <div className="relative w-full max-w-md">
        <Link to="/login" className="inline-flex items-center text-sm text-muted-foreground hover:text-primary mb-6" data-testid="forgot-back-link"><ArrowLeft className="w-4 h-4 mr-1"/>Back to sign in</Link>
        {sent ? (
          <div className="card-soft p-8 text-center" data-testid="forgot-success">
            <div className="w-12 h-12 rounded-full bg-accent flex items-center justify-center mx-auto mb-4">
              <MailCheck className="w-6 h-6 text-primary" />
            </div>
            <h1 className="font-heading text-3xl text-primary">Check your inbox</h1>
            <p className="text-muted-foreground mt-3">
              If an account exists for <span className="font-medium">{email}</span>, we've sent a password reset link. It expires in 30 minutes.
            </p>
            <Button asChild className="mt-6 rounded-full" data-testid="forgot-to-login"><Link to="/login">Back to sign in</Link></Button>
          </div>
        ) : (
          <>
            <h1 className="font-heading text-4xl text-primary">Forgot password?</h1>
            <p className="text-muted-foreground mt-2">Enter your email and we'll send you a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <Label htmlFor="fp-email">Email</Label>
                <Input id="fp-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className="mt-1.5" />
              </div>
              {err && <p className="text-sm text-destructive" data-testid="forgot-error">{err}</p>}
              <Button type="submit" disabled={loading} className="w-full rounded-full h-11 btn-press" data-testid="forgot-submit-btn">
                {loading ? "Sending..." : "Send reset link"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
